import api from './api';
import type { RoadmapSpan } from '../utils/roadmapTimeline';

export interface RoadmapItem extends RoadmapSpan {
  id: number;
  section_name: string;
  section_color: string;
  section_order: number;
  name: string;
  status: 'live' | 'progress' | 'planned' | 'tentative';
  description: string | null;
  timeline_label: string | null;
  parent_id: number | null;
  sort_order: number;
  created_at: string | null;
  updated_at: string | null;
}

export interface RoadmapSection {
  section: string;
  section_color: string;
  section_order: number;
  rows: RoadmapItem[];
}

export interface CreateRoadmapItemRequest extends RoadmapSpan {
  section_name: string;
  section_color: string;
  section_order: number;
  name: string;
  status: string;
  description?: string;
  timeline_label?: string;
  parent_id?: number | null;
  sort_order: number;
}

export interface UpdateRoadmapItemRequest extends Partial<RoadmapSpan> {
  section_name?: string;
  section_color?: string;
  section_order?: number;
  name?: string;
  status?: string;
  description?: string;
  timeline_label?: string;
  parent_id?: number | null;
  sort_order?: number;
}

const roadmapService = {
  async getAll(): Promise<RoadmapSection[]> {
    const response = await api.get('/roadmap');
    return response.data.data;
  },

  async create(data: CreateRoadmapItemRequest): Promise<{ success: boolean; id: number }> {
    const response = await api.post('/roadmap', data);
    return response.data;
  },

  async update(id: number, data: UpdateRoadmapItemRequest): Promise<{ success: boolean }> {
    const response = await api.put(`/roadmap/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<{ success: boolean }> {
    const response = await api.delete(`/roadmap/${id}`);
    return response.data;
  },

  async updatePosition(id: number, span: RoadmapSpan): Promise<{ success: boolean }> {
    const response = await api.put(`/roadmap/${id}/position`, {
      start_year: span.start_year,
      start_month: span.start_month,
      end_year: span.end_year,
      end_month: span.end_month,
    });
    return response.data;
  },

  async reorder(items: { id: number; sort_order: number }[]): Promise<{ success: boolean }> {
    const response = await api.put('/roadmap/bulk/reorder', { items });
    return response.data;
  },
};

export default roadmapService;
